import React from 'react'
import { useFormContext } from 'react-hook-form'

import * as styles from '@/components/form/form.module.scss'
import Link from '@/components/link/link'
import TextElement from '@/components/text-element/text-element'
import { formMessages } from '@/constants/form-messages'
import { type IFormGate, type IFormSubscription } from '@/internal/types/form'

const StepThanks: React.FC = () => {
  const { getValues } = useFormContext()
  const {
    assets,
    newcontact = false,
    form
  } = getValues() as IFormGate | IFormSubscription
  const labels = formMessages[form]
  return (
    <div className="row">
      <div className="text-center">
        <TextElement
          type="h2"
          text={
            newcontact
              ? labels.stepThanksNewContactTitle
              : labels.stepThanksTitle
          }
        />
        <TextElement
          type="h3"
          text={
            newcontact
              ? labels.stepThanksNewContactSubtitle
              : labels.stepThanksSubtitle
          }
        />
        <TextElement
          type="p"
          text={
            newcontact
              ? labels.stepThanksNewContactDescription
              : labels.stepThanksDescription
          }
        />
        {(assets ?? [])
          .map((content, key) => (
            <Link
              to={content.url}
              key={key}
              className={`matomo_download ${assets && assets?.length > 1 ? styles.downloadlink : styles.downloadlinksingle}`}
              openInNewWindow={true}
            >
              {content.externalName}
            </Link>
          ))
          .reverse()}
      </div>
    </div>
  )
}

export default StepThanks
